import React, { Component } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MySwapModal from "../../Modals/MySwapModal";
import ConfirmationModel from "../../Modals/ConfirmationModel";
import adaswaplogo from "../../assets/images/adaswaplogo.png";
import adaswaplogo2 from "../../assets/images/adaswaplogo2.png";
import ada2 from "../../assets/images/ada2.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import "./Swap.css";
import Header from '..//Header/Header';

class Swap extends Component {
  async componentDidMount() {
    // $("body").removeClass("transparent-header");
    // $("html, body").animate({ scrollTop: 0 }, "slow");
  }
  render() {
    return (
      <div>
        <Header />
        <section className="swap">
          <Container>
            <div className="popups-swaping">
              <div className="d-flex justify-content-center align-items-center">
                <div className="swapPage-content">
                  <div className="swap-farm-fields">
                    <div className="field-one">
                      <h2>From</h2>
                    </div>
                    <div className="field-one-iner d-flex justify-content-between align-items-center">
                      <div className="d-flex">
                        <h3>250</h3>
                      </div>
                      <div className="d-flex">
                        <span className="adaswaplogo">
                          <img src={adaswaplogo} alt="" />
                        </span>
                        <MySwapModal />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center align-items-center box-two">
                    <div className="arrow-down-circle">
                      <a href="#" target="_blank">
                        <FontAwesomeIcon icon={faArrowDown} />
                      </a>
                    </div>
                  </div>
                  <div className="swap-farm-fields">
                    <div className="field-one">
                      <h2>To (estimated)</h2>
                    </div>
                    <div className="field-one-iner d-flex justify-content-between align-items-center">
                      <div className="d-flex">
                        <h3>1.28566</h3>
                      </div>
                      <div className="d-flex">
                        <span className="adaswaplogo">
                          <img src={adaswaplogo2} alt="" />
                        </span>
                        <MySwapModal />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center box-two">
                    <div className="d-flex">
                      <h2>Price</h2>
                    </div>
                    <div className="d-flex align-items-center">
                      <h2>192.991 ADA Per ASW</h2>
                      <span className="arrow-down-circle ms-3">
                        <a href="#" target="_blank">
                          <FontAwesomeIcon icon={faSyncAlt} />
                        </a>
                      </span>
                    </div>
                  </div>
                  <div>
                    <ConfirmationModel />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <div className="token-form">
                  <div className="wallet-details">
                    <div className="d-flex justify-content-between mb-1 ">
                      <div className="d-flex">
                        <h2>Minimum received</h2>
                        <span className="question-icon ms-2">
                          <a href="#" target="_blank">
                            <FontAwesomeIcon icon={faQuestionCircle} />
                          </a>
                        </span>
                      </div>
                      <div className="d-flex">
                        <h2>1.289 ASW</h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <div className="d-flex">
                        <h2>Price Impact</h2>
                        <span className="question-icon ms-2">
                          <a href="#" target="_blank">
                            <FontAwesomeIcon icon={faQuestionCircle} />
                          </a>
                        </span>
                      </div>
                      <div className="d-flex">
                        <h2 className="text-theme">&lt;0.01%</h2>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mb-1">
                      <div className="d-flex">
                        <h2>Liquidity Provider Fee</h2>
                        <span className="question-icon ms-2">
                          <a href="#" target="_blank">
                            <FontAwesomeIcon icon={faQuestionCircle} />
                          </a>
                        </span>
                      </div>
                      <div className="d-flex">
                        <h2>0.097 ADA</h2>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2 mt-2">
                    <div className="d-flex">
                      <h2>Route</h2>
                      <span className="question-icon ms-2">
                        <a href="#" target="_blank">
                          <FontAwesomeIcon icon={faQuestionCircle} />
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2 ada-collection">
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="adaswaplogo">
                        <img src={adaswaplogo} alt="" />
                      </span>
                      <h2>ADA</h2>
                      <span className="angle-right-icon ms-2">
                        <a href="#" target="_blank">
                          <FontAwesomeIcon icon={faAngleRight} />
                        </a>
                      </span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="adaswaplogo">
                        <img src={ada2} alt="" />
                      </span>
                      <h2>wETH</h2>
                      <span className="angle-right-icon ms-2">
                        <a href="#" target="_blank">
                          <FontAwesomeIcon icon={faAngleRight} />
                        </a>
                      </span>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="adaswaplogo">
                        <img src={adaswaplogo} alt="" />
                      </span>
                      <h2>ASW</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    );
  }
}
export default Swap;
